import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';

import { showAlert } from '../../store/ducks/alert';

import { CircularProgress } from '@material-ui/core';

import { getActivities } from '../../services/activities'; 


const Activities = ({ location, match }) => {
  const dispatch = useDispatch();
  const [activities, setActivities] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [orderDirections, setOrderDirections] = useState({
    item: 'createdAt',
    direction: 'DESC',
  });

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayActivities(currentPage);
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const headers = ['ip', 'type', 'payload', 'status'];
  const SearchBoxHeaders = ['ip', 'type', 'payload', 'status'];

  const displayActivities = async (currentPage) => {
    try{ 
      setIsLoading(true);

       let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
       if (isSearching) params = { ...searchField, ...params };
       const { data: activities } = await getActivities(currentPage || page, params);
       
       setActivities(activities.rows);
       setTotalItems(activities.count);
       setTotalPages(activities.pages);
       setPage(activities.page);
       setIsLoading(false);
    }catch(error){
      dispatch(showAlert('error', error.message));
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Activities ({totalItems})</h1>
        <SearchBox
          selectItems={SearchBoxHeaders}
          onSubmitSearch={handleSubmitSearch}
          isSearching={isSearching}
          setIsOrdering={setIsOrdering}
        />
      </div>

      <DataTable
        useUid={true}
        head={headers}
        body={activities}
        action={true}
        bodyColumn={headers}
        linkPath={'activities'}
        totalPages={totalPages}
        currentPage={page}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
    </>
  );
};

export default Activities;